import { IMachineChart, IStateTransitionFn } from './machine/types';
import { IWizardFlowContext, WizardFlowAction, WizardFlowState } from './types';

type IWizardTransitionFn = IStateTransitionFn<
  WizardFlowState,
  IWizardFlowContext
>;

const videoPreviewCreating: IWizardTransitionFn = (ctx) => ({
  state: WizardFlowState.VIDEO_PREVIEW_CREATING,
  fn: ctx.createVideoOutput,
});

// NOTE: https://github.com/wix-private/vmaf/pull/292
const isFbIssueFixed = false;

const wizardFlowChart: IMachineChart<
  WizardFlowState,
  WizardFlowAction,
  IWizardFlowContext
> = {
  [WizardFlowState.ONBOARDING]: {
    [WizardFlowAction.NEXT]: (ctx) => ({
      fn: ctx.startWizardSession,
      // TODO: set WizardFlowState.MEDIA_SOURCE as next screen for business when FB ready
      state:
        ctx.isBusiness && isFbIssueFixed
          ? WizardFlowState.MEDIA_SOURCE
          : WizardFlowState.MEDIA_UPLOAD_AND_SELECT,
    }),
  },
  [WizardFlowState.MEDIA_SOURCE]: {
    [WizardFlowAction.BACK]: WizardFlowState.ONBOARDING,
    [WizardFlowAction.NEXT]: WizardFlowState.MEDIA_UPLOAD_AND_SELECT,
  },
  [WizardFlowState.MEDIA_IMPORT]: {
    [WizardFlowAction.BACK]: WizardFlowState.MEDIA_SOURCE,
    [WizardFlowAction.NEXT]: WizardFlowState.MEDIA_UPLOAD_AND_SELECT,
  },
  [WizardFlowState.MEDIA_UPLOAD_AND_SELECT]: {
    [WizardFlowAction.BACK]: (ctx) =>
      // TODO: set WizardFlowState.MEDIA_SOURCE as next screen for business when FB ready
      ctx.isBusiness && isFbIssueFixed
        ? WizardFlowState.MEDIA_SOURCE
        : WizardFlowState.ONBOARDING,
    [WizardFlowAction.NEXT]: (ctx) =>
      ctx.isShortFlowActive
        ? videoPreviewCreating(ctx)
        : WizardFlowState.CUSTOMIZE_THEME,
  },
  [WizardFlowState.CUSTOMIZE_THEME]: {
    [WizardFlowAction.BACK]: WizardFlowState.MEDIA_UPLOAD_AND_SELECT,
    [WizardFlowAction.NEXT]: WizardFlowState.CUSTOMIZE_STYLE,
  },
  [WizardFlowState.CUSTOMIZE_STYLE]: {
    [WizardFlowAction.BACK]: WizardFlowState.CUSTOMIZE_THEME,
    [WizardFlowAction.NEXT]: WizardFlowState.CUSTOMIZE_MUSIC,
  },
  [WizardFlowState.CUSTOMIZE_MUSIC]: {
    [WizardFlowAction.BACK]: WizardFlowState.CUSTOMIZE_STYLE,
    [WizardFlowAction.NEXT]: WizardFlowState.CUSTOMIZE_TEXTS,
  },
  [WizardFlowState.CUSTOMIZE_TEXTS]: {
    [WizardFlowAction.BACK]: WizardFlowState.CUSTOMIZE_MUSIC,
    [WizardFlowAction.NEXT]: (ctx) =>
      ctx.isBusiness
        ? WizardFlowState.CUSTOMIZE_BUSINESS_INFO
        : videoPreviewCreating(ctx),
  },
  [WizardFlowState.CUSTOMIZE_BUSINESS_INFO]: {
    [WizardFlowAction.BACK]: WizardFlowState.CUSTOMIZE_TEXTS,
    [WizardFlowAction.NEXT]: videoPreviewCreating,
  },
  [WizardFlowState.VIDEO_PREVIEW_CREATING]: {
    [WizardFlowAction.BACK]: (ctx) =>
      ctx.isBusiness
        ? WizardFlowState.CUSTOMIZE_BUSINESS_INFO
        : WizardFlowState.CUSTOMIZE_TEXTS,
    [WizardFlowAction.NEXT]: WizardFlowState.VIDEO_PREVIEW,
  },
  [WizardFlowState.VIDEO_PREVIEW]: {
    [WizardFlowAction.BACK]: (ctx) =>
      ctx.isBusiness
        ? WizardFlowState.CUSTOMIZE_BUSINESS_INFO
        : WizardFlowState.CUSTOMIZE_TEXTS,
    [WizardFlowAction.NEXT]: WizardFlowState.OUTPUT,
    [WizardFlowAction.EDIT]: (ctx) =>
      ctx.isShortFlowActive
        ? {
            state: WizardFlowState.MEDIA_UPLOAD_AND_SELECT,
            fn: ctx.deactivateShortFlow(),
          }
        : WizardFlowState.MEDIA_UPLOAD_AND_SELECT,
  },
  [WizardFlowState.OUTPUT]: {},
};

export default wizardFlowChart;
